export const loadTypes = {
  cargo: {
    title: 'بار سنگین'
  },
  furniture: {
    title: 'اسباب‌کشی'
  },
  postage: {
    title: 'مرسوله پستی'
  },
  delivery: {
    title: 'پیک'
  },
  pickup: {
    title: 'بار شهری(وانت)'
  },
  material: {
    title: 'مصالح'
  },
  trash: {
    title: 'نخاله'
  }
}

export const feedbackStatus = [
  { value: null, text: 'انتخاب کنید' },
  { value: -100, text: 'رد شده', enum: 'REJECT' },
  { value: 1, text: 'در انتظار بررسی', enum: 'PENDING' },
  { value: 10, text: 'در حال پیگیری', enum: 'IN_PROGRESS' },
  { value: 100, text: 'تایید شده', enum: 'APPOROVED' }
]
export const clients = [
  { value: null, text: 'انتخاب کنید' },
  { value: 100, text: 'وبسایت', enum: 'WEB' },
  { value: 110, text: 'وبسایت-پنل ادمین', enum: 'WEB_ADMIN' },
  { value: 120, text: 'وبسایت-پنل پروژه', enum: 'WEB_COURIER' },
  { value: 130, text: 'وبسایت-پنل راننده', enum: 'WEB_DRIVER' },
  //   { value: 200, text: 'دسکتاپ', enum: 'DESKTOP' },
  { value: 300, text: 'اپ اندروید', enum: 'ANDROID' },
  { value: 305, text: 'اپ اندروید (PWA)', enum: 'ANDROID_PWA' },
  { value: 306, text: 'اپ اندروید (WebView)', enum: 'ANDROID_WEB_VIEW' },
  //   { value: 310, text: 'اپ اندروید-ادمین', enum: 'ANDROID_ADMIN' },
  //   { value: 315, text: 'اپ اندروید-ادمین (PWA)', enum: 'ANDROID_ADMIN_PWA' },
  //   { value: 316, text: 'اپ اندروید-ادمین (WebView)', enum: 'ANDROID_ADMIN_WEB_VIEW' },
  //   { value: 320, text: 'اپ اندروید-پروژه', enum: 'ANDROID_COURIER' },
  //   { value: 325, text: 'اپ اندروید-پروژه (PWA)', enum: 'ANDROID_COURIER_PWA' },
  //   { value: 326, text: 'اپ اندروید-پروژه (WebView)', enum: 'ANDROID_COURIER_WEB_VIEW' },
  { value: 330, text: 'اپ اندروید-راننده', enum: 'ANDROID_DRIVER' },
  { value: 335, text: 'اپ اندروید-راننده (PWA)', enum: 'ANDROID_DRIVER_PWA' },
  {
    value: 336,
    text: 'اپ اندروید-راننده (WebView)',
    enum: 'ANDROID_DRIVER_WEB_VIEW'
  }
  //   { value: 400, text: 'اپ IOS', enum: 'IOS' },
  //   { value: 405, text: 'اپ IOS (PWA)', enum: 'IOS_PWA' },
  //   { value: 406, text: 'اپ IOS (WebView)', enum: 'IOS_WEB_VIEW' },
]
export const osType = [
  { value: null, text: 'انتخاب کنید' },
  { value: 100, text: 'ویندوز', enum: 'WINDOWS' },
  { value: 200, text: 'مکینتاش', enum: 'MAC' },
  { value: 300, text: 'لینوکس', enum: 'LINUX' },
  { value: 400, text: 'اندروید', enum: 'ANDROID' },
  { value: 500, text: 'اپل', enum: 'IOS' },
  { value: 600, text: 'یونیکس', enum: 'UNIX' },
  { value: 1000, text: 'نامشخص', enum: 'UNKNOWN' }
]

export const loadDefaultItem = 1

export const showShipmentPerPage = 12

export const minimumHour = 4

export const startOfWorkHour = '08:00:00'

export const endOfWorkHour = '20:00:00'

export const weekDays = [
  { value: null, text: 'انتخاب کنید' },
  { value: 1, text: 'شنبه', enum: 'SATURDAY' },
  { value: 2, text: 'یکشنبه', enum: 'SUNDAY' },
  { value: 3, text: 'دوشنبه', enum: 'MONDAY' },
  { value: 4, text: 'سه شنبه', enum: 'TUESDAY' },
  { value: 5, text: 'چهارشنبه', enum: 'WEDNESDAY' },
  { value: 6, text: 'پنجشنبه', enum: 'THURSDAY' },
  { value: 7, text: 'جمعه', enum: 'FRIDAY' }
]

export const pageSize = [
  { value: 10, text: '10' },
  { value: 20, text: '20' },
  { value: 50, text: '50' },
  { value: 100, text: '100' }
]

export const limitType = [
  { value: null, text: 'انتخاب کنید', enum: null },
  { value: 1, text: 'روز', enum: 'DAY' },
  { value: 2, text: 'دقیقه', enum: 'MINUTE' },
  { value: 3, text: 'عدد صحیح', enum: 'INTEGER' }
]

export const shipmentUpdateTypes = [
  { value: null, text: 'انتخاب کنید', enum: null },
  { value: 1, text: 'جزئیات', enum: 'INFO' },
  { value: 2, text: 'مبدا', enum: 'ORIGIN' },
  { value: 3, text: 'مقصد', enum: 'DESTINATION' },
  { value: 4, text: 'خودرو', enum: 'CAR' },
  { value: 5, text: 'نیروی فنی', enum: 'EMPLOYEE' },
  { value: 6, text: 'اقلام', enum: 'ITEM' }
]

export const dictionaryTypes = [
  { value: 1, title: 'شهر', enum: 'CITY' },
  { value: 2, title: 'استان', enum: 'PROVINCE' }
]

export const dictionaryExternalSystems = [
  { value: 1, title: 'چاپار', text: 'چاپار', enum: 'CHAPAR' },
  { value: 2, title: 'ماهکس', text: 'ماهکس', enum: 'MAHEX' }
]

export const dictionaryMissType = [
  { value: null, text: 'انتخاب کنید', enum: null },
  { value: 1, text: 'دیکشنری', enum: 'DICTIONARY' },
  { value: 2, text: 'وب سرویس', enum: 'WEBSERVICE' }
]

export const paymentTypes = [
  { value: null, text: 'انتخاب کنید', enum: null },
  { value: 20, text: 'پرداخت در مقصد', enum: 'DICTIONARY' },
  { value: 10, text: 'پرداخت اعتباری', enum: 'WEBSERVICE' }
]

export const supportedTicketExtensions = [
  '.jpg',
  '.jpeg',
  '.png',
  '.pdf',
  '.docx',
  '.xlsx'
]
